import { PLAN_TYPE } from "./plan.type";

export enum SUBSCRIPTION_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  EXPIRED = "EXPIRED",
}

export type Addition = {
  label: string;
  value: string;
  key: string;
}
export type Split = {
  id: string;
  walletId: string;
  fixedValue: number | null;
  percentualValue: number | null;
  totalValue: number;
  cancellationReason: string | null;
  status: string;
  externalReference: string | null;
  description: string | null;
};

export type SplitPayment = {
  walletId: string;
  percentualValue: number;
};


export interface ISubscription {
  _id?: string;
  renterId: string;
  planId?: string;
  planName: string;
  subscriptionType: PLAN_TYPE;
  value: number;
  totalPayments: number;
  externalReferences: {
    asaasSubscriptionId: string;
    asaasCustomerId: string;
  };
  nextDueDate: Date;
  endDate: Date;
  status: SUBSCRIPTION_STATUS;
  updatedAt: Date;
  createdAt: Date;
  maxPayments: number;
  additions: Addition[];
  split?: Split[];
  fine?: boolean;
  licensePlate?: string
  splitEnabled?: boolean;
  splitConfig?: SplitPayment[];
  vehicleId?: string;
  partnerId?: string;
  paymentsNegotiated?: string[];
  weeklyValue?: number;
  author?: string;
  deleteReason?: string;
}

export const emptySubscription: ISubscription = {
  _id: "",
  renterId: "",
  planId: "",
  planName: "",
  subscriptionType: PLAN_TYPE.MONTHLY,
  value: 0,
  totalPayments: 0,
  externalReferences: {
    asaasSubscriptionId: "",
    asaasCustomerId: "",
  },
  nextDueDate: new Date(),
  endDate: new Date(),
  status: SUBSCRIPTION_STATUS.ACTIVE,
  updatedAt: new Date(),
  createdAt: new Date(),
  maxPayments: 0,
  additions: [],
  split: [],
  paymentsNegotiated: [],
  weeklyValue: 0,
  author: "",
  deleteReason: "",
}
